import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { StateHelperService } from '@Core/services/proprietary/state-helper.service';
import { PageObjectModule } from '../page/page-object.module';
import { ProjectObjectService } from './project-object.service';
import { ProjectObjectState } from './project-object.state';

@NgModule({
    imports: [NgxsModule.forFeature([ProjectObjectState]), PageObjectModule],
    providers: [ProjectObjectService, StateHelperService]
})
export class ProjectObjectModule { }
